import type { FieldErrors, FieldValues, Resolver } from "react-hook-form";
import type { ZodType } from "zod";

export function zodResolver<T extends FieldValues>(schema: ZodType<T>): Resolver<T> {
  return async (values) => {
    const result = await schema.safeParseAsync(values);
    if (result.success) return { values: result.data, errors: {} };
    const errors: FieldErrors<T> = {};
    for (const issue of result.error.issues) {
      const path = issue.path.join(".");
      if (!path) continue;
      const segments = path.split(".");
      let cursor: Record<string, unknown> = errors;
      segments.forEach((segment, index) => {
        if (index === segments.length - 1) cursor[segment] = { type: issue.code, message: issue.message };
        else cursor = (cursor[segment] ||= {}) as Record<string, unknown>;
      });
    }
    return { values: {}, errors };
  };
}
